var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountCircle = function SvgAccountCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.5 7.5c0 3.03-2.47 5.5-5.5 5.5a5.51 5.51 0 0 1-5.5-5.5C6.5 4.47 8.97 2 12 2s5.5 2.47 5.5 5.5m-2 0C15.5 5.57 13.93 4 12 4S8.5 5.57 8.5 7.5 10.07 11 12 11s3.5-1.57 3.5-3.5M4 17c0-1.65 1.35-3 3-3h10c1.65 0 3 1.35 3 3v5h-2v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5H4z",
    clipRule: "evenodd"
  })));
};
export { SvgAccountCircle as Icon };
export default __webpack_public_path__ + "static/media/dd3d922a03a96f913cb1b6b6944e164c.svg";